module.exports = __webpack_public_path__ + "static/media/3-item-e.02feb0f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/3-item-e.jpg
// module id = 1166
// module chunks = 33